import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';

export default class DemoCartItem extends Model {
  static table = 'demo_cart_items';

  @field('product_id') productId!: string;
  @field('variant_id') variantId!: string;
  @field('quantity') quantity!: number;
  @field('mass') mass!: number;
  @field('unit_price') unitPrice!: number;
  @field('price_type') priceType!: string;
  @field('name') name!: string;
  @field('unit_of_mass') unitOfMass!: string;
  @field('category') category!: string;
  @field('image') image!: string;
  @field('created_at') createdAt!: number;

  // Helper to convert to plain object matching cart item structure
  toCartItemObject() {
    return {
      _id: this.id,
      product_id: this.productId,
      variant_id: this.variantId || undefined,
      quantity: this.quantity,
      mass: this.mass,
      unit_price: this.unitPrice,
      price_type: this.priceType,
      name: this.name,
      unit_of_mass: this.unitOfMass,
      category: this.category,
      image: this.image,
      created_at: this.createdAt,
    };
  }

  // Calculate total based on price type
  getTotal(): number {
    if (this.priceType === 'per_mass') {
      return this.unitPrice * this.mass;
    }
    return this.unitPrice * this.quantity;
  }
}
